import { __assign, __rest } from "tslib";
import React from 'react';
import VeltCommentDialogThreadCardAttachmentsImage from './VeltCommentDialogThreadCardAttachmentsImage/VeltCommentDialogThreadCardAttachmentsImage';
import VeltCommentDialogThreadCardAttachmentsOther from './VeltCommentDialogThreadCardAttachmentsOther/VeltCommentDialogThreadCardAttachmentsOther';
import { transformWireframeProps } from '../../../../utils/propUtils';
var VeltCommentDialogThreadCardAttachments = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-thread-card-attachments-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogThreadCardAttachments.Other = VeltCommentDialogThreadCardAttachmentsOther;
VeltCommentDialogThreadCardAttachments.Image = VeltCommentDialogThreadCardAttachmentsImage;
export default VeltCommentDialogThreadCardAttachments;
